/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundInfoForDesktop {
  /** Название **/
  name: string;
  /** Строящееся **/
  underConstruction: boolean;
  /** Является ли это метро основным для объекта **/
  isDefault: boolean;
  /** Цвет линии метро, hex **/
  lineColor?: TUndergroundInfoForDesktop_LineColor;
  /** Способ передвижения до метро **/
  transportType?: TUndergroundInfoForDesktop_TransportType;
  /** Время в пути в минутах до метро, мин **/
  time?: TUndergroundInfoForDesktop_Time;
  /** Полный url для перехода к поиску по этому гео **/
  fullUrl?: TUndergroundInfoForDesktop_FullUrl;
  /** Год введения в эксплуатацию (заполняется для строящихся) **/
  releaseYear?: TUndergroundInfoForDesktop_ReleaseYear;
}

export type TUndergroundInfoForDesktop_LineColor = null | string;

export type TUndergroundInfoForDesktop_TransportType = null | ETransportType;

export enum ETransportType {
  /** Пешком **/
  'Walk' = 'walk',
  /** Транспортом **/
  'Transport' = 'transport',
}
export type TUndergroundInfoForDesktop_Time = null | number;

export type TUndergroundInfoForDesktop_FullUrl = null | string;

export type TUndergroundInfoForDesktop_ReleaseYear = null | number;
